import { defineMessages } from 'react-intl';

/* eslint-disable max-len */
const messages = defineMessages({
  title: {
    id: 'App.ViewProperty.AffordableSetup.WaitlistV2.ApplicationsNeedingInfoModal.Title',
    defaultMessage:
      '{count, plural, one {# Application Needs} other {# Applications Need}} More Information',
  },
  intro: {
    id: 'App.ViewProperty.AffordableSetup.WaitlistV2.ApplicationsNeedingInfoModal.Intro',
    defaultMessage:
      'Before you can change your Waitlist Settings, {count, plural, one {# application needs} other {# applications need}} some additional information for the Affordable Waitlist.',
  },
  optionsIntro: {
    id: 'App.ViewProperty.AffordableSetup.WaitlistV2.ApplicationsNeedingInfoModal.OptionsIntro',
    defaultMessage: 'You have two options for completing this information:',
  },
  updateYourselfTitle: {
    id: 'App.ViewProperty.AffordableSetup.WaitlistV2.ApplicationsNeedingInfoModal.UpdateYourselfTitle',
    defaultMessage: '1. Update the applications yourself',
  },
  updateYourselfBody: {
    id: 'App.ViewProperty.AffordableSetup.WaitlistV2.ApplicationsNeedingInfoModal.UpdateYourselfBody',
    defaultMessage:
      'Open each applicant’s profile and add the missing information by clicking “Add to Waitlist” in the Waitlist Summary section.',
  },
  askFortressTitle: {
    id: 'App.ViewProperty.AffordableSetup.WaitlistV2.ApplicationsNeedingInfoModal.AskFortressTitle',
    defaultMessage: '2. Ask Fortress to update them for you',
  },
  askFortressBody: {
    id: 'App.ViewProperty.AffordableSetup.WaitlistV2.ApplicationsNeedingInfoModal.AskFortressBody',
    defaultMessage:
      'Contact Fortress Support to request an import. We’ll send you a spreadsheet to complete with the missing information, then import those updates for you.',
  },
  outro: {
    id: 'App.ViewProperty.AffordableSetup.WaitlistV2.ApplicationsNeedingInfoModal.Outro',
    defaultMessage:
      'Once {count, plural, one {the application is} other {all # applications are}} updated, you’ll be able to make changes to your Waitlist Settings.',
  },
  continue: {
    id: 'App.ViewProperty.AffordableSetup.WaitlistV2.ApplicationsNeedingInfoModal.Continue',
    defaultMessage: 'Continue',
  },
});

export default messages;
